(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.getElementById('site-header');
    var drawer = document.getElementById('site-drawer');
    var openBtn = document.querySelector('[data-open-menu]');
    if (!header) return;

    var onScroll = function() {
      header.classList.toggle('is-scrolled', window.scrollY > 20);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var scrollToId = function(id) {
      var target = document.getElementById(id);
      if (!target) return false;
      header.classList.add('is-scrolled');
      target.classList.add('is-visible');
      target.querySelectorAll('.es-reveal').forEach(function(el) {
        el.classList.add('is-visible');
      });
      target.scrollIntoView({ block: 'start' });
      return true;
    };

    document.addEventListener('click', function(event) {
      var link = event.target.closest('a[href*="#"]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href) return;
      var hashAt = href.indexOf('#');
      if (hashAt === -1) return;
      var id = href.slice(hashAt + 1);
      if (!id || !document.getElementById(id)) return;
      var linkPath = (href.slice(0, hashAt) || window.location.pathname).replace(/\/$/, '') || '/';
      var currentPath = (window.location.pathname || '/').replace(/\/$/, '') || '/';
      if (linkPath !== currentPath) return;
      event.preventDefault();
      if (typeof closeMenu === 'function' && drawer && drawer.open) closeMenu();
      window.requestAnimationFrame(function() {
        scrollToId(id);
        if (history.replaceState) history.replaceState(null, '', '#' + id);
      });
    });

    if (window.location.hash.length > 1) {
      window.requestAnimationFrame(function() {
        scrollToId(window.location.hash.slice(1));
      });
    }

    if (!drawer || !openBtn) return;

    var setExpanded = function(open) {
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    var openMenu = function() {
      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
      drawer.setAttribute('scroll-lock', '');
      setExpanded(true);
    };

    var closeMenu = function() {
      if (typeof drawer.close === 'function' && drawer.open) {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }
      drawer.removeAttribute('scroll-lock');
      setExpanded(false);
    };

    openBtn.addEventListener('click', openMenu);
    drawer.querySelectorAll('[data-close-menu]').forEach(function(el) {
      el.addEventListener('click', function(event) {
        if (el.tagName === 'BUTTON') event.preventDefault();
        closeMenu();
      });
    });
    drawer.addEventListener('close', function() {
      drawer.removeAttribute('scroll-lock');
      setExpanded(false);
    });
    drawer.addEventListener('click', function(event) {
      if (event.target === drawer) closeMenu();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
